import Text from "@pathwright/ui/src/components/ui/Text"
import { DEFAULT_FONT_FAMILY } from "@pathwright/ui/src/components/ui/typography"
import styled from "styled-components"

const Wrapper = styled(Text.Meta)`
  ${(p) =>
    p.style && p.style.fontSize
      ? `
  &, 
  p {
    font-size: ${p.style.fontSize};
  }
  `
      : ""}

  /* font-size: 0.7em; */
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${DEFAULT_FONT_FAMILY};

  p {
    margin: 0;
  }

  ${(p) =>
    p.style && p.style.color
      ? `
  &,
  p {
    color: ${p.style.color};
  } 
      `
      : `
  &,
  p {
    color: #292e35;

  }
      `}
`

const MetaText = ({ text, html, children, style }) => {
  if (!text && !children && !html) return null

  if (html) {
    return (
      <Wrapper
        className="MetaText"
        dangerouslySetInnerHTML={{ __html: html }}
        style={style}
      />
    )
  }

  const output = children ? children : text

  return (
    <Wrapper className="MetaText" style={style}>
      {output}
    </Wrapper>
  )
}

export default MetaText
